module.exports = __webpack_public_path__ + "static/media/ax.3301f616.svg";